type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'PermissionAssociated'
const nameSource = 'users/permissionsAssociated'
const namePageTitle = 'Permissões Associadas'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Permissões Associadas',
  to: '/users/permissionsAssociated',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/users/permissionsAssociated/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/users/permissionsAssociated/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Atualizar',
    to: '/users/permissionsAssociated/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
